import React from 'react';

export default function Navbar() {
  return (
    <nav 
      className="navbar navbar-expand-xl navbar-dark sticky-top shadow-sm border-bottom border-secondary border-opacity-10" 
      style={{ 
        backgroundColor: 'var(--glass-bg)', 
        backdropFilter: 'blur(12px)', 
        WebkitBackdropFilter: 'blur(12px)' 
      }}
    >
      <div className="container">
        <a className="navbar-brand d-flex align-items-center gap-2 py-2" href="#hero">
          <div className="bg-primary bg-opacity-10 rounded p-1.5 border border-primary border-opacity-20 d-flex align-items-center justify-content-center">
            <i className="bi bi-droplet-fill text-primary fs-4"></i>
          </div>
         <div className="d-flex flex-column gap-1.5 h-sm">
  <span className="fw-bold text-white tracking-wide fs-5">SOCIETY FOR THE "WATER"</span>
  <span className="text-warning font-monospace extra-small tracking-wider fw-bold">ISO 9001:2008 CERTIFIED ORGANISATION</span> 
</div>
        </a>

        <button className="navbar-toggler border-0 p-2" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          {/* text-nowrap use kiya taaki koi bhi link mobile ya desktop par break na ho */}
          <ul className="navbar-nav ms-auto align-items-center gap-1 mt-3 mt-xl-0 font-monospace text-nowrap">
            <li className="nav-item w-100 w-xl-auto"><a className="nav-link px-3 py-2 text-white-50 transition-all rounded" href="#about">About</a></li>
            <li className="nav-item w-100 w-xl-auto"><a className="nav-link px-3 py-2 text-white-50 transition-all rounded" href="#focus-areas">Focus Areas</a></li>
            <li className="nav-item w-100 w-xl-auto"><a className="nav-link px-3 py-2 text-white-50 transition-all rounded" href="#projects">Presence</a></li>
            <li className="nav-item w-100 w-xl-auto"><a className="nav-link px-3 py-2 text-white-50 transition-all rounded" href="#performance">Impact</a></li>
            <li className="nav-item w-100 w-xl-auto"><a className="nav-link px-3 py-2 text-white-50 transition-all rounded" href="#financials">Financials</a></li>
            <li className="nav-item w-100 w-xl-auto"><a className="nav-link px-3 py-2 text-white-50 transition-all rounded" href="#team">Team</a></li>
            <li className="nav-item w-100 w-xl-auto ms-xl-2 mt-2 mt-xl-0">
              <a className="btn btn-sm btn-primary bg-gradient rounded-pill px-3 py-1.5 fw-bold text-uppercase font-monospace extra-small d-inline-flex align-items-center gap-1.5" href="#performance">
                <i className="bi bi-shield-check-fill text-warning"></i> National Registry
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}